<div class="px-5 pb-6 lg:px-8 xl:px-12">
  @if (displayAddressSearchInput) {
    <div class="my-3 lg:hidden">
      <app-shop-search-location-input
        [fieldBackgroundColor]="shopSearchLocationFieldBackgroundColor"
        [fieldTextColor]="shopSearchLocationFieldTextColor"
        [fieldPlaceholderColor]="shopSearchLocationFieldPlaceholderColor"
        [fieldIconColor]="shopSearchLocationFieldIconColor"
      ></app-shop-search-location-input>
    </div>
  }
  <div class="flex items-center lg:justify-between">
    @if (this.displayTitle) {
      <div class="hidden lg:block">
        <h2 class="font-accent text-4.5xl font-bold text-neutral-800">
          {{ title | translate }}
        </h2>
      </div>
    }
    <div class="flex items-center">
      @if (displayFiltersButton) {
        <app-button-atom
          [icon]="'icon-filter'"
          [size]="'S'"
          [type]="'light'"
          [label]="
            (nbFilters$ | async)
              ? ('shop-list-header.filter' | translate) + ' (' + (nbFilters$ | async) + ')'
              : ('shop-list-header.filter' | translate)
          "
          [color]="'primary'"
          class="mr-2"
          (clickEventEmitter)="openFilters()"
        ></app-button-atom>
      }
      @if (displayMapButton) {
        <app-button-atom
          class="ml-2"
          [ngClass]="{ hidden: !displayMapButtonOnMobile, 'lg:block': !displayMapButtonOnMobile }"
          [type]="'primary'"
          [icon]="'icon-distance'"
          [size]="'S'"
          [color]="'primary'"
          [overrideBgColor]="shopsMapButtonColor"
          [overrideTextColor]="shopsMapButtonTextColor"
          [label]="'shop-list-header.show-map' | translate"
          (clickEventEmitter)="navigateToMapPage()"
        ></app-button-atom>
      }
    </div>
  </div>
  <div>
    @if (selectedFilters$ | async; as filters) {
      @if (filters.length) {
        <div class="mt-6">
          @for (filterValues of filters; track filterValues) {
            <div class="inline-block">
              @for (filter of filterValues.values; track filter) {
                <div class="mb-3 mr-3 inline-block">
                  <app-chip-atom
                    [label]="filter.label"
                    [value]="filter.value"
                    [id]="filterValues.id"
                    (removeChip)="removeFilter(filterValues, $event)"
                  ></app-chip-atom>
                </div>
              }
            </div>
          }
        </div>
      }
    }
    @if (selectedCategories$ | async; as categories) {
      @if (categories.length) {
        <div class="mt-6">
          @for (category of categories; track category) {
            <div class="mb-3 mr-3 inline-block">
              <app-chip-atom
                [label]="category.name"
                [value]="category"
                [id]="category.id"
                (removeChip)="removeCategoryFilter($event)"
              ></app-chip-atom>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
